// Action types
const SET_COVER = 'scratch-gui/publish/SET_COVER';
const SET_PIC = 'scratch-gui/publish/SET_PIC';
const SET_PROJECT_FILE = 'scratch-gui/publish/SET_PROJECT_FILE';

const initialState = {
    cover: null,
    pic: null,
    projectFile: null,
};

// Reducers
const reducer = function (state, action) {
    if (typeof state === 'undefined') state = initialState;
    switch (action.type) {
        case SET_COVER:
            return Object.assign({}, state, {
                cover: action.value
            });
        case SET_PIC:
            return Object.assign({}, state, {
                pic: action.value
            });
        case SET_PROJECT_FILE:
            return Object.assign({}, state, {
                projectFile: action.value
            });
        default:
            return state;
    }
}

// Action creators
const setCover = cover => ({
    type: SET_COVER,
    value: cover
});

const setPic = pic => ({
    type: SET_PIC,
    value: pic
});

const setProjectFile = projectFile => ({
    type: SET_PROJECT_FILE,
    value: projectFile
});

export {
    reducer as default,
    initialState as publishInitialState,
    setCover,
    setPic,
    setProjectFile,
};